import { NgModule } from "@angular/core";
import { SharedModule } from "app/shared/shared.module";
import { JsxComponent } from "./jsx.component";

@NgModule({
    imports: [SharedModule],
    declarations: [JsxComponent],
    exports: [JsxComponent],
})
export class JsxModule {}